import axios from 'axios';

export class SettingService {
  async getPublicSettings() {
    return await axios.get('/api/v1/app-settings');
  }

  async getSettings() {
    return await axios.get('/api/v1/portal/app-settings');
  }

  async updateSettings(data) {
    return await axios.post('/api/v1/portal/app-settings', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  async getEventNotifications(params = {}) {
    return await axios.get('/api/v1/portal/event-notifications', { params });
  }

  async retryEventNotification(notificationId) {
    return await axios.post(`/api/v1/portal/event-notifications/${notificationId}/retry`);
  }

  async getCarrierIntegrations() {
    return await axios.get('/api/v1/portal/carrier-integrations');
  }

  async createCarrierIntegration(data) {
    return await axios.post('/api/v1/portal/carrier-integrations', data);
  }

  async updateCarrierIntegration(integrationId, data) {
    return await axios.patch(`/api/v1/portal/carrier-integrations/${integrationId}`, data);
  }

  async rotateCarrierSecret(integrationId) {
    return await axios.post(`/api/v1/portal/carrier-integrations/${integrationId}/rotate-secret`);
  }

  async retryCarrierEvent(eventId) {
    return await axios.post(`/api/v1/portal/carrier-events/${eventId}/retry`);
  }
}

export default SettingService;
